module.exports = __webpack_public_path__ + "static/advice3-3e894e3171b0a86f427da39cc3c96913.png";